// ImageBlock — renders an image asset. The src is resolved server-side
// (the embed endpoint emits a thumbnail URL alongside the asset id;
// blocks should be given the URL, not the id, so they don't fetch).
// For v1 the layout default mappings pass `src` directly; step 6 will
// have the Designer override layer carry asset ids that the endpoint
// resolves before reaching the React side.

import type { BlockUniversalProps } from "./types";

export interface ImageBlockProps extends BlockUniversalProps {
  src?: string | null;
  alt?: string;
  /** Width/height hints if the layout's CSS needs them. */
  fit?: "contain" | "cover";
}

export function ImageBlock({ src, alt, fit = "contain", themeVariant, className }: ImageBlockProps) {
  if (!src) return null;
  return (
    <div
      className={"sd-block-image" + (className ? " " + className : "")}
      data-variant={themeVariant}
      data-fit={fit}
    >
      <img src={src} alt={alt ?? ""} draggable={false} />
    </div>
  );
}
